import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../utils/icons';
import './Header.css';

function Header({ location, lastUpdated, onRefresh, loading }) {
  const formatLastUpdated = (date) => {
    if (!date) return 'Never';
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1 className="header-title">
          <Icon name="sun" size={24} className="header-icon" />
          Weather Operations Dashboard
        </h1>
        {location && (
          <span className="header-location">
            <Icon name="mapPin" size={14} /> {location}
          </span>
        )}
      </div>

      <div className="header-right">
        <div className="last-updated">
          <span className="update-label">Last Updated:</span>
          <span className="update-time">{formatLastUpdated(lastUpdated)}</span>
        </div>

        <div className="header-actions">
          <button
            className={`refresh-btn ${loading ? 'loading' : ''}`}
            onClick={onRefresh}
            disabled={loading}
          >
            <Icon name="refresh" size={16} className={loading ? 'spinning' : ''} />
            {loading ? 'Updating...' : 'Refresh'}
          </button>

          <div className="status-indicator">
            <span className={`status-dot ${loading ? 'updating' : 'live'}`}></span>
            <span className="status-text">{loading ? 'Updating' : 'Live'}</span>
          </div>

          <Link to="/tv" className="tv-mode-link">
            <Icon name="monitor" size={16} />
            <span>Open TV Display</span>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;